import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import React from 'react';
import { useMediaQuery } from '@/hooks/use-media-query';
import AtsEnhancementsSection from './sections/AtsEnhancementsSection';
import { WordMatchData, WordMatchVisual } from './sections/KeywordMatch';


interface SheetWrapperProps {
  title: string;
  description: string;
  isOpen: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  width?: string;
  wordMatchData?: WordMatchData;
  atsEnhancementsData?: {
    heading: string;
    contents: Array<{title: string, content: string}>;
  };
}



const SheetWrapper: React.FC<SheetWrapperProps> = ({
  isOpen,
  handleClose,
  children,
  title,
  description,
  width = 'flex flex-col pb-0',
  wordMatchData,
  atsEnhancementsData,
}) => {
  const isMobile = useMediaQuery('(max-width: 640px)');
  const isJobFitSheet = !!wordMatchData;
  const isAtsEnhancements = !!atsEnhancementsData;

  return (
    <Sheet open={isOpen} onOpenChange={handleClose}>
      <SheetContent
        side={isMobile ? 'bottom' : 'right'}
        className={`${width} ${isMobile ? 'h-[82vh]' : 'h-full'} overflow-y-auto no-scrollbar`}
      >
        <SheetHeader>
          <SheetTitle className="text-2xl">{title}</SheetTitle>
          <SheetDescription>{description}</SheetDescription>
        </SheetHeader>

        {children}
        {isAtsEnhancements && <AtsEnhancementsSection data={atsEnhancementsData} />}
        {isJobFitSheet && <WordMatchVisual data={wordMatchData} />}
      </SheetContent>
    </Sheet>
  );
};

export default SheetWrapper;
